import React from 'react'

import Timeline from '../../common/timeline/Timeline'
import { useViewTimeOffMonthly } from '../../../queries/queries'
import { timeOffViewTypes } from '../../../utils/constants/timeOffViewTypes'

const TimeOffMonthly: React.FC = () => {
  const { data, isLoading } = useViewTimeOffMonthly()

  return (
    <Timeline data={data} isLoading={isLoading} type={timeOffViewTypes.MONTHLY} />
  )
}

export default TimeOffMonthly
